// ─── API ──────────────────────────────────────────────────────────────────────

export const API_BASE = 'https://tbl.zerdegroup.kz/api/v1';

// ─── Table Layout ─────────────────────────────────────────────────────────────

/**
 * CSS grid-template-columns для строк журнала (пользователь).
 * 11 колонок: № | Наименование | Производитель | Серия | Срок | Кол уп | Кол шт | Цена | Сумма | Дата записи | Действия
 */
export const GRID_TEMPLATE_COLUMNS =
  '44px minmax(180px,2fr) minmax(120px,1fr) 110px 110px 80px 80px 90px 100px 110px 80px';

export const MIN_TABLE_WIDTH = 1200;

// ─── Pagination ───────────────────────────────────────────────────────────────

export const DEFAULT_PAGE_LIMIT = 50;

// ─── Column Definitions ───────────────────────────────────────────────────────

export interface ColumnDef {
  id: string;
  label: string;
  width: string;
  sortable?: boolean;
}

export const COLUMN_DEFS: ColumnDef[] = [
  { id: 'num',        label: '№',             width: '44px' },
  { id: 'name',       label: 'Наименование',  width: 'minmax(180px,2fr)', sortable: true },
  { id: 'producer',   label: 'Производитель', width: 'minmax(120px,1fr)', sortable: true },
  { id: 'serial',     label: 'Серия',         width: '110px',             sortable: true },
  { id: 'expiry',     label: 'Срок годности', width: '110px',             sortable: true },
  { id: 'qty',        label: 'Кол-во уп.',    width: '80px',              sortable: true },
  { id: 'qtyPcs',     label: 'Кол-во шт.',    width: '80px',              sortable: true },
  { id: 'price',      label: 'Цена',          width: '90px',              sortable: true },
  { id: 'totalSum',   label: 'Сумма',         width: '100px',             sortable: true },
  { id: 'recordDate', label: 'Дата записи',   width: '110px',             sortable: true },
  { id: 'actions',    label: '',              width: '80px' },
];
